import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const addUpdatedGroup = (list, newRecord) => {
  const oldRecordIndex = list.findIndex(
    (item) => item.groupId === newRecord.groupId
  );
  return [
    ...list.slice(0, oldRecordIndex),
    newRecord,
    ...list.slice(oldRecordIndex + 1),
  ];
};

export const technicianGroups = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_TECHNICIAN_GROUP]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.FETCHING_TECHNICIAN_GROUPS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TECHNICIAN_GROUPS]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'list': action.response.data,
      };
    },
    [ActionTypes.FETCHED_TECHNICIAN_GROUPS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.ADDING_TECHNICIAN_GROUP]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_TECHNICIAN_GROUP]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [action.response.data, ...state.list],
    }),
    [ActionTypes.ADDED_TECHNICIAN_GROUP_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_TECHNICIAN_GROUP]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.UPDATED_TECHNICIAN_GROUP]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'list': addUpdatedGroup(state.list, action.response.data),
    }),
    [ActionTypes.UPDATED_TECHNICIAN_GROUP_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
    }),
  })(state, action);
};
